import {Checkbox} from "@/components/checkbox/Checkbox.tsx";
import {
  ArrayFilterCategory,
  FilterSets,
  getMatchModeKey,
  MatchMode,
} from "@/components/filterDropdown/FilterDropdown.ts";
import {MatchModeToggle} from "@/components/matchModeToggle/MatchModeToggle.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";

import styles from "../FilterDropdown.module.scss";

interface ArrayOptionsProps {
  category: ArrayFilterCategory;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  localFilterSets: FilterSets<ArrayFilterCategory>;
  onToggleOption: (categoryId: string, optionValue: string) => void;
  onMatchModeChange: (categoryId: string, mode: MatchMode) => void;
}

export const ArrayOptions = ({
  category,
  searchQuery,
  onSearchChange,
  localFilterSets,
  onToggleOption,
  onMatchModeChange,
}: ArrayOptionsProps) => {
  const filteredOptions =
    category.options?.filter((opt) => opt.display.toString().toLowerCase().includes(searchQuery.toLowerCase())) || [];

  const optionsToDisplay = category.sorted
    ? [...filteredOptions].sort((a, b) => a.display.toString().localeCompare(b.display.toString()))
    : filteredOptions;

  const matchModeKey = getMatchModeKey(category.key);
  const currentMatchMode =
    ((localFilterSets as Record<string, unknown>)[matchModeKey] as MatchMode) ?? category.matchMode?.default ?? "OR";

  return (
    <div className={styles.rightPane}>
      {category.key !== "status" && (
        <div className={styles.searchContainer}>
          <SearchInput className={styles.searchInput} value={searchQuery} onChange={onSearchChange} />
        </div>
      )}

      {category.matchMode?.enabled && (
        <MatchModeToggle
          value={currentMatchMode}
          onChange={(mode) => onMatchModeChange(category.key, mode)}
          variant="compact"
          className={styles.matchRow}
        />
      )}

      <div className={styles.optionsList}>
        {optionsToDisplay.map((opt) => (
          <Checkbox
            key={opt.key}
            id={opt.key}
            checked={((localFilterSets[category.key] as string[]) || []).includes(opt.key)}
            onChange={() => onToggleOption(category.key, opt.key)}
            label={opt.display}
          />
        ))}
      </div>
    </div>
  );
};
